import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { ConfigService } from '../services/config.service';

export const SKIP_BASE_URL = new HttpContextToken<boolean>(() => false);

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(ConfigService);

  if (/^https?:\/\//i.test(req.url) || req.context.get(SKIP_BASE_URL)) {
    return next(req);
  }

  const base = config.apiBaseUrl.replace(/\/+$/, '');
  const path = req.url.replace(/^\/+/, '');

  return next(req.clone({ url: `${base}/${path}` }));
};
